
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {FacultyFellowshipSpecialisationModel} from '../model/faculty_fellowship_specialisation.model';
import {API_URLS} from '../utils/api_url.util';
import { API_UTILS} from '../utils/api_utils.util'
import { catchError } from 'rxjs/operators';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FacultyFellowshipSpecialisationService {
  items:FacultyFellowshipSpecialisationModel[];

  constructor(private http: HttpClient) {
    this.items = null;
  }


  
   getItems(facultyId:string): Observable<Array<FacultyFellowshipSpecialisationModel>>{
    let items$ = this.http
      .get<Array<FacultyFellowshipSpecialisationModel>>(API_URLS.API_GET_FACULTY_FELLOWSHIP_SPECIALISATIONS+`/${facultyId}`)
      .pipe(         catchError(handleError)       )
      return items$;
  }


    



   addItem(item:FacultyFellowshipSpecialisationModel): Observable<FacultyFellowshipSpecialisationModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };


    let items$ = this.http
      
      .post<FacultyFellowshipSpecialisationModel>(API_URLS.API_ADD_FACULTY_FELLOWSHIP_SPECIALISATION,body,options)
      .pipe(         catchError(handleError)       )
      return items$;  
    
  }

    
 

 editItem(item:FacultyFellowshipSpecialisationModel): Observable<FacultyFellowshipSpecialisationModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };
    let id=item.Id;

    let items$ = this.http
      
      .post<FacultyFellowshipSpecialisationModel>(API_URLS.API_EDIT_FACULTY_FELLOWSHIP_SPECIALISATION,body,options)
       .pipe(         catchError(handleError)       )
      return items$;


    }




  removeItem(item:FacultyFellowshipSpecialisationModel): Observable<FacultyFellowshipSpecialisationModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options =  { headers: headers };
    let id=item.Id;

    let items$ = this.http
      .get<FacultyFellowshipSpecialisationModel>(API_URLS.API_REMOVE_FACULTY_FELLOWSHIP_SPECIALISATION+`/${id}`)
      .pipe(         catchError(handleError)       )
      return items$;
    
  }








 
}




// this could also be a private method of the component class
function handleError (error: HttpErrorResponse) {
  // log error
  // could be something more sofisticated
  console.error(error);

  return observableThrowError(error.error);

  
 }